var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageFrameContainer',[_c('h2',[_vm._v(" Pay Pal Payment ")])])}
var staticRenderFns = []

export { render, staticRenderFns }